import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/name_24px@2x.png'
import _imports_1 from '@/assets/icons/language_black_24dp@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-3d9558c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fs-15 fw-700" }
const _hoisted_2 = {
  class: "input-with-icon mt-8",
  style: {"max-width":"46rem"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "icon-20",
    alt: "icons_name_24px@2x"
  })
], -1))
const _hoisted_4 = { class: "fs-15 fw-700 mt-16" }
const _hoisted_5 = {
  class: "input-with-icon mt-8",
  style: {"max-width":"46rem"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "icon-20",
    alt: "icons_name_24px@2x"
  })
], -1))
const _hoisted_7 = { class: "fs-15 fw-700 mt-16" }
const _hoisted_8 = {
  class: "select-with-icon mt-8",
  style: {"max-width":"46rem"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-left flex-mid" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "icon-20",
    alt: "icons_language_black_24dp@2x"
  })
], -1))
const _hoisted_10 = { class: "flex mt-32" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("myAccount.First_Name")), 1),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(`input-44-0000000d ${
          _ctx.user.firstName ? 'validate-false' : 'validate-true'
        }`),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.firstName) = $event)),
        type: "text",
        placeholder: ""
      }, null, 2), [
        [_vModelText, _ctx.user.firstName]
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("myAccount.Last_Name")), 1),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(`input-44-0000000d ${
          _ctx.user.lastName ? 'validate-false' : 'validate-true'
        }`),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.lastName) = $event)),
        type: "text",
        placeholder: ""
      }, null, 2), [
        [_vModelText, _ctx.user.lastName]
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("myAccount.Language")), 1),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_select, {
        modelValue: _ctx.lang,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lang) = $event)),
        class: "select-login e-input-52",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "English",
            value: "en"
          }),
          _createVNode(_component_el_option, {
            label: "ภาษาไทย",
            value: "th"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveMyProfile())),
        class: "btn btn-50 btn-primary",
        style: {"width":"11.4rem"}
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("btn.Save")), 1)
      ])
    ])
  ]))
}